import { Formik } from "formik";

const StepThree = ({step, nextStep, prevStep, handleFormData, values }) => {
    return (
        <div>
            <div className="border-b-2 py-4">
					<div className="uppercase tracking-wide text-xs font-bold text-gray-500 mb-1 leading-tight">{`Step: ${step} of 6`}</div>
					<div className="flex flex-col md:flex-row md:items-center md:justify-between">
						<div className="flex-1">
							<div>
								<div className="text-md font-bold text-gray-800 leading-tight">Certificates: COC / Watchkeeping</div>
							</div>
						</div>

						<div className="flex items-center ml-4 md:w-64">
							<div className="w-full bg-white rounded-full mr-2">
								<div className="rounded-full bg-green-500 text-xs leading-none h-2 text-center text-white" style={{ width: '50%' }}></div>
							</div>
							<div className="text-xs w-10 text-gray-600">50%</div>
						</div>
					</div>
            </div>
            <Formik
			initialValues={{ 
				indian_coc_no: "",
                indian_coc_issue_date: "",
                indian_coc_issue_date_on: "",
                indian_coc_valid_till: "",
                other_grade: "",
                other_grade_issue_date: "",
                other_grade_issue_date_on: "",
                other_grade_valid_till: "",
                deck_cert_no: "",
                deck_cert_issue_date: "",
                deck_cert_issue_date_on: "",
                deck_cert_valid_till: "",
			}}
        validate={values => {
            const errors = {};
            return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
            try{	
            handleFormData(values);
            setSubmitting(false);
            nextStep();
            }catch(e){
                console.log(e)
            }
        }}
        >
        {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            /* and other goodies */
        }) => (
	    <form onSubmit={handleSubmit}>
            <div className="py-10">
            <div className="mb-5">

                <div className="grid grid-cols-5 gap-4">
                    <div className="col-span-2 sm:col-span-2">
                        <div className="mb-5">
                            <label for="indian_coc_no" className="font-bold mb-1 text-sm text-gray-800 block"> Indian COC No.</label>
                            <input type="text"
                                name='indian_coc_no'
                                id='indian_coc_no'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.indian_coc_no}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your indian COC no..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="coc_issue_at" className="font-bold mb-1 text-sm text-gray-800 block">Issue At</label>
                            <input type="text"
                                name='indian_coc_issue_date'
                                id='indian_coc_issue_date'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.indian_coc_issue_date}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your issue at..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="issue_date_on" className="font-bold mb-1 text-sm text-gray-800 block">On</label>
                            <input type="date"
                                name='indian_coc_issue_date_on'
                                id='indian_coc_issue_date_on'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.indian_coc_issue_date_on}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your on date..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="issue_date" className="font-bold mb-1 text-sm text-gray-800 block">Valid Till</label>
                            <input type="date"
                                name='indian_coc_valid_till'
                                id='indian_coc_valid_till'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.indian_coc_valid_till}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your valid till..."/>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-5 gap-4">
                    <div className="col-span-2 sm:col-span-2">
                        <div className="mb-5">
                            <label for="other_grade" className="font-bold mb-1 text-sm text-gray-800 block">Other (Grade)</label>
                            <input type="text"
                                name='other_grade'
                                id='other_grade'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.other_grade}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your seaman book no..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="grade_issue_at" className="font-bold mb-1 text-sm text-gray-800 block">Issue At</label>
                            <input type="text"
                                name='other_grade_issue_date'
                                id='other_grade_issue_date'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.other_grade_issue_date}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your issue date..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="issue_date_on" className="font-bold mb-1 text-sm text-gray-800 block">On</label>
                            <input type="date"
                                name='other_grade_issue_date_on'
                                id='other_grade_issue_date_on'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.other_grade_issue_date_on}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your on date..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="issue_date" className="font-bold mb-1 text-sm text-gray-800 block">Valid Till</label>
                            <input type="date"
                                name='other_grade_valid_till'
                                id='other_grade_valid_till'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.other_grade_valid_till}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your valid till..."/>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-5 gap-4">
                    <div className="col-span-2 sm:col-span-2">
                        <div className="mb-5">
                            <label for="deck_watch_keeping" className="font-bold mb-1 text-sm text-gray-800 block">Deck/ Engine Watch keeping Cert. No.</label>
                            <input type="text"
                                name='deck_cert_no'
                                id='deck_cert_no'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deck_cert_no}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your seaman book no..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="deck_issue_at" className="font-bold mb-1 text-sm text-gray-800 block">Issue At</label>
                            <input type="text"
                                name='deck_cert_issue_date'
                                id='deck_cert_issue_date'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deck_cert_issue_date}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your issue date..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="issue_date_on" className="font-bold mb-1 text-sm text-gray-800 block">On</label>
                            <input type="date"
                                name='deck_cert_issue_date_on'
                                id='deck_cert_issue_date_on'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deck_cert_issue_date_on}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your on date..."/>
                        </div>
                    </div>
                    <div className="col-span-1 sm:col-span-1">
                        <div className="mb-5">
                            <label for="issue_date" className="font-bold mb-1 text-sm text-gray-800 block">Valid Till</label>
                            <input type="date"
                                name='deck_cert_valid_till'
                                id='deck_cert_valid_till'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deck_cert_valid_till}
                                className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                placeholder="Enter your valid till..."/>
                        </div>
                    </div>
                </div>

                </div>
            </div>

            <div className=" bottom-0 left-0 right-0 py-5">
			<div className="max-w-3xl mx-auto px-4">
				<div className="flex justify-between">

                    <div className="w-1/2">
						<button
                            onClick={()=> prevStep() }
							className="w-32 focus:outline-none py-2 px-5 rounded-md shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium text-gray-800 text-sm border" 
						>Previous</button>
					</div>

					<div className="w-1/2 text-right">
						<button
							type="submit"
                            disabled={isSubmitting}
							className="w-32 focus:outline-none border border-transparent py-2 px-5 rounded-md shadow-sm text-center text-white bg-orange-500 hover:bg-orange-600 font-medium text-sm" 
						>Next</button>
					</div>
				</div>
			</div>
            </div>
        </form>)}
        </Formik>
        </div>
    )
}

export default StepThree;